import { Flex, Skeleton, Typography } from 'antd'
import './index.scss'
import { useTranslation } from 'react-i18next'
import RichTextField from 'src/app/shared/components/common/rich-text-field'

interface PropEmail {
  data: any
  isLoading: boolean
}

const EmailTemplate = (props: PropEmail) => {
  const { t } = useTranslation()
  const { data, isLoading } = props
  return (
    <Flex gap={12} vertical={true} className='template-mail'>
      {!isLoading ? (
        <>
          <Flex align='start'>
            <Typography.Text style={{ fontWeight: 700, paddingRight: 5, fontSize: '24px', lineHeight: '32px' }}>
              {data?.subject}
            </Typography.Text>
          </Flex>
          <Flex>
            {/* <LogoEmail /> */}
            <Flex
              style={{
                width: 50,
                height: 50,
                background: 'linear-gradient(180deg, #E11D34 0%, #A32036 100%)',
                borderRadius: 100,
              }}
              align='center'
              justify='center'
            >
              <Typography style={{ fontSize: '28px', fontWeight: 600, color: 'white' }}>B</Typography>
            </Flex>
            <Flex vertical={true} style={{ paddingLeft: 12 }}>
              <div>
                <Typography.Text style={{ fontWeight: 700, paddingRight: 5 }}>
                  {t('SentEmailLog:detailEmail.bankFraudAlerts')}
                </Typography.Text>
                <Typography.Text className='mail-sub-text'>{data?.dateSent}</Typography.Text>
              </div>
              <Typography.Text className='mail-sub-text'>
                {t('SentEmailLog:detailEmail.to')} {data?.emailAddress}
              </Typography.Text>
            </Flex>
          </Flex>
          <Flex vertical>
            <Typography.Text>
              <RichTextField richText={data?.content} />
            </Typography.Text>
          </Flex>
        </>
      ) : (
        <Skeleton />
      )}
    </Flex>
  )
}
export default EmailTemplate
